const LOCALIZATION_REGEX = /\/(uk|aus)\/?/;

export default LOCALIZATION_REGEX;
